import './App.css';
import DubaiTourismHomepage from './Pages/HomePage';

function App() {
  return (
    <div className="App">
      <DubaiTourismHomepage />
    </div>
  );
}

export default App;
